
import Collapse from 'bootstrap/js/dist/collapse';

jQuery(document).ready(function ($) {

		// $('.navbar-toggler').on('click', function() {
		// 	window.navPosition =  $(window).scrollTop();
		// })
		$('.navbar-toggler').on('click', function() {
			// Toggle the inner icon state.
			$(this).find('i, .navbar-toggler-icon').toggleClass('cancel');
		});

		$(window).scroll(function() {
			if ($(this).scrollTop() > 200) {
				$('.header__navbar--navy .featured').fadeIn(200);
			}
			if ($(this).scrollTop() < 200) {
				$('.header__navbar--navy .featured').fadeOut(200);
			}
			// if ($(this).width() < 1200) {
			// 	if (($(this).scrollTop() > (window.navPosition + 200)) || ($(this).scrollTop() < (window.navPosition - 200)) ) {
			//
			// 		$('#navbarNavDropdown').removeClass('show');
			// 		$('.navbar-toggler').addClass('collapsed');
			// 	}
			// }
		});

		// Manual bootstrap collapse control for the mobile nav (ensures proper toggle state).
		const navbarMenu = document.getElementById('navbarMenu');
		const navbarToggler = document.querySelector('.navbar-toggler');
		const navbar = document.getElementById('navbar');

		if (navbarMenu && navbarToggler) {
			// Ensure the data API is not toggling automatically; we manage it manually.
			navbarToggler.removeAttribute('data-bs-toggle');
			navbarToggler.removeAttribute('data-bs-target');

			// Manual bootstrap collapse control for the mobile nav (ensures proper toggle state).
			const collapse = Collapse.getOrCreateInstance(navbarMenu, { toggle: false });

			const syncToggler = () => {
				const isShown = navbarMenu.classList.contains('show');
				navbarToggler.classList.toggle('collapsed', !isShown);
				navbarToggler.setAttribute('aria-expanded', isShown ? 'true' : 'false');
			};

			const closeMenu = () => collapse.hide();

			// Only our handler toggles the menu (avoids double toggles).
			navbarToggler.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopImmediatePropagation();
				collapse.toggle();
			});

			// Close on any menu link tap (mobile UX).
			navbarMenu.querySelectorAll('a').forEach((link) => {
				link.addEventListener('click', () => {
					if (navbarMenu.classList.contains('show')) {
						closeMenu();
					}
				});
			});

			navbarMenu.addEventListener('shown.bs.collapse', syncToggler);
			navbarMenu.addEventListener('hidden.bs.collapse', syncToggler);

			syncToggler();

			// Disable legacy sticky behaviour (class `is-fixed` caused layout issues).
			// We leave the navbar in normal flow; no scroll listener needed.
		}
});
